import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";

import { isPrintMode } from "commons/src/QueryParameter";

import { Login } from "./Login";
import { authenticate } from "../../components/DataOperations";

function LoginContainerComponent({
    isLoading,
    failedLogIn,
    clientId,
    adviserId,
    registrationUser,
    termsAccepted,
    location
}) {
    const { search } = useLocation();
    return (
        <Login
            authenticate={authenticate}
            isLoading={isLoading}
            failedLogIn={failedLogIn}
            location={location}
            clientId={clientId}
            adviserId={adviserId}
            registrationUser={registrationUser}
            termsAccepted={termsAccepted}
            isPrintMode={isPrintMode(search)}
        />
    );
}

const mapStateToProps = state => ({
    clientId: state.user.id,
    adviserId: state.user.adviserId,
    registrationUser: state.user.registrationUser,
    termsAccepted: state.user.termsAccepted,
    isLoading: state.applicationContext.isLoading,
    failedLogIn: state.applicationContext.failedLogIn
});

LoginContainerComponent.propTypes = {
    clientId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    adviserId: PropTypes.string,
    location: PropTypes.object,
    registrationUser: PropTypes.string,
    termsAccepted: PropTypes.bool,
    isLoading: PropTypes.bool,
    failedLogIn: PropTypes.bool
};

export const LoginContainer = connect(mapStateToProps)(LoginContainerComponent);
